"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mozzo": {
    "1bf627ae": [{
      "hkey": "2783718a",
      "slug": "mozzo",
      "name": "Mozzo",
      "primary": true,
      "skipSearch": false
    }],
    "borghetto": [{
      "hkey": "2783718a",
      "slug": "mozzo",
      "name": "Mozzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc488b26": [{
      "hkey": "2783718a",
      "slug": "mozzo",
      "name": "Mozzo",
      "primary": true,
      "skipSearch": false
    }],
    "dorotina": [{
      "hkey": "2783718a",
      "slug": "mozzo",
      "name": "Mozzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2584384a": [{
      "hkey": "2783718a",
      "slug": "mozzo",
      "name": "Mozzo",
      "primary": true,
      "skipSearch": false
    }],
    "pascoletto": [{
      "hkey": "2783718a",
      "slug": "mozzo",
      "name": "Mozzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;